/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import CourseAndModulesLayout from "./ModulesAndChapterLayout";
import {  useParams } from "react-router-dom";
import { useGetModulesChapterQuery } from "src/services/ChapterServices";
import { useGetAllModulesQuery } from "src/services/ModuleServices";

const ModulesAndChapterLayoutWrapper = () => { 

 const {moduleId} = useParams()

 // Get Chapter list data
  const {data , isLoading , isFetching}= useGetModulesChapterQuery(moduleId  ,{skip:!moduleId}) 

  // Get module list data
  const { data:modulesData, isLoading:modulesLoading, isFetching:modulesFetching } = useGetAllModulesQuery("");
 
  return (
    <CourseAndModulesLayout
      allModules={modulesData?.data}
      moduleIsLoading={modulesLoading ||modulesFetching } // module list loading State
      chaptersIsLoading={isFetching ||isLoading } // chapter list loading State
      allchapters={data?.data}
      
    />
  );
};

export default ModulesAndChapterLayoutWrapper;
